import { Box, List } from '@mui/material';
import React from 'react';
import route from '../../utils/Routes';
import SDListItem from './SDListItem';
import selHome from '../../assets/svg/selHome.svg';
import deselHome from '../../assets/svg/deselHome.svg';

import selCatalog from '../../assets/svg/selCatalog.svg';
import deselCatalog from '../../assets/svg/deselCatalog.svg';

import selProdReqList from '../../assets/svg/selProdReqList.svg';
import deselProdReqList from '../../assets/svg/deselProdReqList.svg';

import selNewProdReqList from '../../assets/svg/selNewProdReqList.svg';
import deselNewProdReqList from '../../assets/svg/deselNewProdReqList.svg';

import selPurOrderList from '../../assets/svg/selPurOrderList.svg';
import deselPurOrderList from '../../assets/svg/deSelPurOderList.svg';


import selProjList from '../../assets/svg/selProjList.svg';
import deselProjList from '../../assets/svg/deSelProjList.svg';

import selUserList from '../../assets/svg/selUserList.svg';
import deselUserList from '../../assets/svg/deSelUserList.svg';

import comSel from '../../assets/svg/comSel.svg';
import comDeSel from '../../assets/svg/comDeSel.svg';

import prodapprSel from '../../assets/svg/prodappr.svg';
import prodapprDeSel from '../../assets/svg/prodapprdesel.svg';

import potSel from '../../assets/svg/potSel.svg';
import potDeSel from '../../assets/svg/potDeSel.svg';

import archiveSel from '../../assets/svg/archiveSel.svg';
import archiveDeSel from '../../assets/svg/archiveDeSel.svg';

import { useAuthContext } from '../../context/AuthContext';
import constants from '../../utils/Constants';

function SideDrawer() {
    const { ctxtUser } = useAuthContext();
    const reqMenuItems = [
        {
            title: 'Home',
            selImgPath: selHome,
            deSelImgPath: deselHome,
            path: ctxtUser?.isComUser ? route.comDashboard : route.adminDash,
            selsStyle: {
                height: '1.45rem',
                marginLeft: '0.1rem',
                marginRight: '0.1rem',
            },
            deSelStyle: {
                height: '1.45rem',
                marginLeft: '0.1rem',
                marginRight: '0.1rem',
            },
        },
        {
            title: 'Products',
            selImgPath: selCatalog,
            deSelImgPath: deselCatalog,
            path: ctxtUser?.isComUser ? route.comCataLog : route.aCataLog,
            selsStyle: {
                height: '1.45rem',
                marginLeft: '0.1rem',
                marginRight: '0.1rem',
            },
            deSelStyle: {
                height: '1.45rem',
                marginLeft: '0.1rem',
                marginRight: '0.1rem',
            },
        },
        ...((ctxtUser?.userType === constants.focalPoint || ctxtUser?.userType === constants.lineManager) ? [
            {
                title: 'Order Request List',
                selImgPath: selPurOrderList,
                deSelImgPath: deselPurOrderList,
                path: route.cPolist,
                selsStyle: {
                    height: '1.45rem',
                    marginLeft: '0.1rem',
                    marginRight: '0.1rem',
                },
                deSelStyle: {
                    height: '1.45rem',
                    marginLeft: '0.1rem',
                    marginRight: '0.1rem',
                },
            },

        ] : []),
        {
            title: 'Order Request Tracking',
            selImgPath: potSel,
            deSelImgPath: potDeSel,
            path: route.cPoTracking,
            selsStyle: {
                height: '1.45rem',
                marginLeft: '0.1rem',
                marginRight: '0.1rem',
            },
            deSelStyle: {
                height: '1.45rem',
                marginLeft: '0.1rem',
                marginRight: '0.1rem',
            },
        },
        {
            title: 'Product Request List',
            selImgPath: selProdReqList,
            deSelImgPath: deselProdReqList,
            path: route.cProdreqlist,
            selsStyle: {
                height: '1.45rem',
                marginLeft: '0.1rem',
                marginRight: '0.1rem',
            },
            deSelStyle: {
                height: '1.45rem',
                marginLeft: '0.1rem',
                marginRight: '0.1rem',
            },
        },
        {
            title: 'New Product Request List',
            selImgPath: selNewProdReqList,
            deSelImgPath: deselNewProdReqList,
            path: route.cNewProdreqlist,
            selsStyle: {
                height: '1.45rem',
                marginLeft: '0.1rem',
                marginRight: '0.1rem',
            },
            deSelStyle: {
                height: '1.45rem',
                marginLeft: '0.1rem',
                marginRight: '0.1rem',
            },
        },
        ...((ctxtUser?.userType === constants.focalPoint) ? [
            {
                title: 'Project List',
                selImgPath: selProjList,
                deSelImgPath: deselProjList,
                path: route.cProjectList,
                selsStyle: {
                    height: '1.45rem',
                    marginLeft: '0.1rem',
                    marginRight: '0.1rem',
                },
                deSelStyle: {
                    height: '1.45rem',
                    marginLeft: '0.1rem',
                    marginRight: '0.1rem',
                },
            },
            {
                title: 'Project Employee List',
                selImgPath: selUserList,
                deSelImgPath: deselUserList,
                path: route.cProjEmpList,
                selsStyle: {
                    height: '1.45rem',
                    marginLeft: '0.1rem',
                    marginRight: '0.1rem',
                },
                deSelStyle: {
                    height: '1.45rem',
                    marginLeft: '0.1rem',
                    marginRight: '0.1rem',
                },
            },
        ] : []),

    ]
    const amtcMenuItems = [
        ...((ctxtUser?.userType !== constants.accounts) ? [
            {
                title: 'Home',
                selImgPath: selHome,
                deSelImgPath: deselHome,
                path: ctxtUser?.isComUser ? route.comDashboard : route.adminDash,
                selsStyle: {
                    height: '1.45rem',
                    marginLeft: '0.1rem',
                    marginRight: '0.1rem',
                },
                deSelStyle: {
                    height: '1.45rem',
                    marginLeft: '0.1rem',
                    marginRight: '0.1rem',
                },
            },
            {
                title: 'Products',
                selImgPath: selCatalog,
                deSelImgPath: deselCatalog,
                path: ctxtUser?.isComUser ? route.comCataLog : route.aCataLog,
                selsStyle: {
                    height: '1.45rem',
                    marginLeft: '0.1rem',
                    marginRight: '0.1rem',
                },
                deSelStyle: {
                    height: '1.45rem',
                    marginLeft: '0.1rem',
                    marginRight: '0.1rem',
                },
            },
        ] : []),

        ...((ctxtUser?.userType === constants.store) ? [
            {
                title: 'Order Request List',
                selImgPath: selPurOrderList,
                deSelImgPath: deselPurOrderList,
                path: route.aStorePoList,
                selsStyle: {
                    height: '1.45rem',
                    marginLeft: '0.1rem',
                    marginRight: '0.1rem',
                },
                deSelStyle: {
                    height: '1.45rem',
                    marginLeft: '0.1rem',
                    marginRight: '0.1rem',
                },
            },
            {
                title: 'Order Request Tracking',
                selImgPath: potSel,
                deSelImgPath: potDeSel,
                path: route.aSelCom,
                selsStyle: {
                    height: '1.45rem',
                    marginLeft: '0.1rem',
                    marginRight: '0.1rem',
                },
                deSelStyle: {
                    height: '1.45rem',
                    marginLeft: '0.1rem',
                    marginRight: '0.1rem',
                },
            }
        ] : []),
        ...((ctxtUser?.userType === constants.admin || ctxtUser?.userType === constants.sourcing || ctxtUser?.userType === constants.accounts) ?
            [
                {
                    title: 'Order Request List',
                    selImgPath: selPurOrderList,
                    deSelImgPath: deselPurOrderList,
                    path: route.aPolist,
                    selsStyle: {
                        height: '1.45rem',
                        marginLeft: '0.1rem',
                        marginRight: '0.1rem',
                    },
                    deSelStyle: {
                        height: '1.45rem',
                        marginLeft: '0.1rem',
                        marginRight: '0.1rem',
                    },
                },
                {
                    title: 'Order Request Tracking',
                    selImgPath: potSel,
                    deSelImgPath: potDeSel,
                    path: route.aSelCom,
                    selsStyle: {
                        height: '1.45rem',
                        marginLeft: '0.1rem',
                        marginRight: '0.1rem',
                    },
                    deSelStyle: {
                        height: '1.45rem',
                        marginLeft: '0.1rem',
                        marginRight: '0.1rem',
                    },
                },
            ] : []),
        ...((ctxtUser?.userType === constants.admin || ctxtUser?.userType === constants.sourcing) ? [
            {
                title: 'Company List',
                selImgPath: comSel,
                deSelImgPath: comDeSel,
                path: route.aCompanies,
                selsStyle: {
                    height: '1.45rem',
                    marginLeft: '0.1rem',
                    marginRight: '0.1rem',
                },
                deSelStyle: {
                    height: '1.45rem',
                    marginLeft: '0.1rem',
                    marginRight: '0.1rem',
                },
            },
        ] : []),
        ...((ctxtUser?.userType === constants.admin) ? [
            {
                title: 'Waiting For Product Approval List',
                selImgPath: prodapprSel,
                deSelImgPath: prodapprDeSel,
                path: route.aProdApprWaitList,
                selsStyle: {
                    height: '1.45rem',
                    marginLeft: '0.1rem',
                    marginRight: '0.1rem',
                },
                deSelStyle: {
                    height: '1.45rem',
                    marginLeft: '0.1rem',
                    marginRight: '0.1rem',
                },
            },
            {
                title: 'AMTC Employee List',
                selImgPath: selUserList,
                deSelImgPath: deselUserList,
                path: route.aAmtcEmpList,
                selsStyle: {
                    height: '1.45rem',
                    marginLeft: '0.1rem',
                    marginRight: '0.1rem',
                },
                deSelStyle: {
                    height: '1.45rem',
                    marginLeft: '0.1rem',
                    marginRight: '0.1rem',
                },
            },
        ] : []),
        ...((ctxtUser?.userType === constants.sourcing || ctxtUser?.userType === constants.admin) ? [
            {
                title: 'New Product Request List',
                selImgPath: selNewProdReqList,
                deSelImgPath: deselNewProdReqList,
                path: route.aNewProdreqlist,
                selsStyle: {
                    height: '1.45rem',
                    marginLeft: '0.1rem',
                    marginRight: '0.1rem',
                },
                deSelStyle: {
                    height: '1.45rem',
                    marginLeft: '0.1rem',
                    marginRight: '0.1rem',
                },
            },
        ] : []),
        ...((ctxtUser?.userType === constants.admin) ? [
            {
                title: 'Archived Products',
                selImgPath: archiveSel,
                deSelImgPath: archiveDeSel,
                path: route.aArchiveprods,
                selsStyle: {
                    height: '1.45rem',
                    marginLeft: '0.1rem',
                    marginRight: '0.1rem',
                },
                deSelStyle: {
                    height: '1.45rem',
                    marginLeft: '0.1rem',
                    marginRight: '0.1rem',
                },
            },
        ] : []),
        ...((ctxtUser?.userType === constants.sourcing) ? [
            {
                title: 'Manual PO Entry',
                selImgPath: selUserList,
                deSelImgPath: deselUserList,
                path: route.aManualEntry,
                selsStyle: {
                    height: '1.45rem',
                    marginLeft: '0.1rem',
                    marginRight: '0.1rem',
                },
                deSelStyle: {
                    height: '1.45rem',
                    marginLeft: '0.1rem',
                    marginRight: '0.1rem',
                },
            },
        ] : []),
    ];


    return (
        <Box height={'100%'}
            sx={{
                borderRight: 1, borderColor: '#E3E3E3', overflow: "hidden",
                overflowY: "scroll",
                '&::-webkit-scrollbar': {
                    width: 4
                }
            }}>
            <List>
                {((ctxtUser?.isComUser) ? reqMenuItems : amtcMenuItems).map(
                    (i) => (
                        <SDListItem i={i} key={i.title} />
                    )
                )}
            </List>
        </Box>
    );
}

export default SideDrawer;


// const boMenuItems = [
//     {
//         title: 'Home',
//         selImgPath: selHome,
//         deSelImgPath: deselHome,
//         path: ctxtUser?.userType === constants.admin ? route.adminDash : route.comDashboard,
//         selsStyle: {
//             height: '1.45rem',
//             marginLeft: '0.1rem',
//             marginRight: '0.1rem',
//         },
//         deSelStyle: {
//             height: '1.45rem',
//             marginLeft: '0.1rem',
//             marginRight: '0.1rem',
//         },
//     },
//     {
//         title: 'Inventory',
//         selImgPath: selCatalog,
//         deSelImgPath: deselCatalog,
//         path: ctxtUser?.isComUser ? route.comCataLog : route.aCataLog,
//         selsStyle: {
//             height: '1.45rem',
//             marginLeft: '0.1rem',
//             marginRight: '0.1rem',
//         },
//         deSelStyle: {
//             height: '1.45rem',
//             marginLeft: '0.1rem',
//             marginRight: '0.1rem',
//         },
//     },
//     {
//         title: 'Company List',
//         selImgPath: comSel,
//         deSelImgPath: comDeSel,
//         path: route.aCompanies,
//         selsStyle: {
//             height: '1.45rem',
//             marginLeft: '0.1rem',
//             marginRight: '0.1rem',
//         },
//         deSelStyle: {
//             height: '1.45rem',
//             marginLeft: '0.1rem',
//             marginRight: '0.1rem',
//         },
//     },
//     {
//         title: 'Waiting For Product Approval List',
//         selImgPath: prodapprSel,
//         deSelImgPath: prodapprDeSel,
//         path: route.aProdApprWaitList,
//         selsStyle: {
//             height: '1.45rem',
//             marginLeft: '0.1rem',
//             marginRight: '0.1rem',
//         },
//         deSelStyle: {
//             height: '1.45rem',
//             marginLeft: '0.1rem',
//             marginRight: '0.1rem',
//         },
//     },
//     {
//         title: 'Product Request List',
//         selImgPath: selProdReqList,
//         deSelImgPath: deselProdReqList,
//         path: route.reqProductReqList,
//         selsStyle: {
//             height: '1.45rem',
//             marginLeft: '0.1rem',
//             marginRight: '0.1rem',
//         },
//         deSelStyle: {
//             height: '1.45rem',
//             marginLeft: '0.1rem',
//             marginRight: '0.1rem',
//         },
//     },

//     {
//         title: 'Order Request List',
//         selImgPath: selPurOrderList,
//         deSelImgPath: deselPurOrderList,
//         path: route.purchaseOrderList,
//         selsStyle: {
//             height: '1.45rem',
//             marginLeft: '0.1rem',
//             marginRight: '0.1rem',
//         },
//         deSelStyle: {
//             height: '1.45rem',
//             marginLeft: '0.1rem',
//             marginRight: '0.1rem',
//         },
//     },
//     {
//         title: 'Project List',
//         selImgPath: selProjList,
//         deSelImgPath: deselProjList,
//         path: route.projectList,
//         selsStyle: {
//             height: '1.45rem',
//             marginLeft: '0.1rem',
//             marginRight: '0.1rem',
//         },
//         deSelStyle: {
//             height: '1.45rem',
//             marginLeft: '0.1rem',
//             marginRight: '0.1rem',
//         },
//     },
//     {
//         title: 'New Product Request List',
//         selImgPath: selNewProdReqList,
//         deSelImgPath: deselNewProdReqList,
//         path: route.reqNewProductReqList,
//         selsStyle: {
//             height: '1.45rem',
//             marginLeft: '0.1rem',
//             marginRight: '0.1rem',
//         },
//         deSelStyle: {
//             height: '1.45rem',
//             marginLeft: '0.1rem',
//             marginRight: '0.1rem',
//         },
//     },
//     {
//         title: 'User List',
//         selImgPath: selUserList,
//         deSelImgPath: deselUserList,
//         path: route.userList,
//         selsStyle: {
//             height: '1.45rem',
//             marginLeft: '0.1rem',
//             marginRight: '0.1rem',
//         },
//         deSelStyle: {
//             height: '1.45rem',
//             marginLeft: '0.1rem',
//             marginRight: '0.1rem',
//         },
//     },

// ];